class Intranet {

	constructor() {
		this.login();
	}

	login() {
    $('#toggle-password-visibility').on('click', function(){
      $(this).parent().find('input').attr('type', ($(this).parent().find('input').attr('type') == 'text' ? 'password' : 'text'));
      $(this).toggleClass('show');
    });
	}
}

export default Intranet;
